import { render, staticRenderFns } from "./ShippingDashboard.vue?vue&type=template&id=3afcfdbc&scoped=true&"
import script from "./ShippingDashboard.vue?vue&type=script&lang=js&"
export * from "./ShippingDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ShippingDashboard.vue?vue&type=style&index=0&id=3afcfdbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afcfdbc",
  null
  
)

export default component.exports